import { State } from "./State";
import App from "../../../core/src/App";
import GameEvents from "../const/GameEvents";
import UIController from "../../src/ui/UIController";
import { UIStates } from "../../src/ui/UIStates";
import AutoplayModel from "../model/AutoplayModel";
import SpinModel from "../model/SpinModel";
import KeyboardManager, { Key } from "../../src/utils/KeyboardManager";
import GameModel from "../model/GameModel";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";
import ReelGroup from "../views/ReelGroup";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";

export default class SpinResultState extends State {
    protected skipping: boolean;

    public enter(): void {
        super.enter();
        this.skipping = false;
        this.stopReels();
        this.checkAuto();
        this.setSkipWithSpace();
    }

    protected setSkipWithSpace = () => {
        if (KeyboardManager.isPressed(Key.SPACE)) {
            this.skipWithKey();
        } else {
            KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        }
    }

    public canExit(): boolean {
        return GameModel.canSkipSpin();
    }

    protected skipWithKey() {
        if(GameModel.alowSpaceToSkipSpin()){
            this.skip();
        }
    }

    public skip() {
        if (!this.skipping) {
            // App.dispatcher.emit(GameEvents.STOP_SPIN);
            UIController.setState(UIStates.STOP_SPIN);
            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            let reels = Array.from(Array(reelGroup.reels.length).keys());
            let result = SpinModel.getStopSymbolsForReels(reels);
            reelGroup.stopImmediately(result);
            this.skipping = true;
        }
    }

    protected stopReels() {
        GameModel.setSpinDelay(0);
        UIController.setState(UIStates.SPIN_RESULT);
        App.dispatcher.once(
            GameEvents.ALL_REELS_STOPPED,
            () => {
                // SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
                this.exit();
            },
            this
        );
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        let reels = Array.from(Array(reelGroup.reels.length).keys());
        let result = SpinModel.getStopSymbolsForReels(reels);
        reelGroup.stop(result);
    }

    protected checkAuto() {
        if (AutoplayModel.isAutoSpinActive()) {
            if (
                AutoplayModel.checkLossLimitReached() ||
                AutoplayModel.checkWinLimitReached(SpinModel.winAmount) ||
                AutoplayModel.checkTotalWinLimitReached() ||
                AutoplayModel.checkStopOnAnyWin(SpinModel.winAmount) ||
                AutoplayModel.checkStopOnBigWin(SpinModel.winAmount)
                // AutoplayModel.stopOnFeatureWin
            ) {
                // AutoplayModel.setAutoSpin(0);
                CommandManager.execute(Commands.STOP_AUTOPLAY);
                CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS);
            }
        }
    }

    public exit() {
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey, this);
        super.exit();
    }
}
